<script setup>
import { useDocument } from '@/composables/useDocument'
import { useRoute, useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'update',
    subject: 'Document',
  },
})

const route = useRoute()
const router = useRouter()
const documentId = computed(() => route.params.id)

const { document, loading, saving, fetchDocument, updateDocument } = useDocument()

const form = ref({ title: '' })
const errors = ref({})

onMounted(async () => {
  await fetchDocument(documentId.value)
  form.value.title = document.value?.title ?? ''
})

const save = async () => {
  errors.value = {}
  try {
    await updateDocument(documentId.value, form.value)
    router.push({ name: 'document-id', params: { id: documentId.value } })
  } catch (e) {
    if (e?.status === 422) errors.value = e?.data?.errors ?? {}
    else console.error('Update document error:', e)
  }
}
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-4">
      Edit Dokumen
    </h4>

    <VProgressLinear
      v-if="loading"
      indeterminate
      color="primary"
      class="mb-3"
    />

    <VCard
      v-if="document"
      max-width="640"
    >
      <VCardText class="pa-6">
        <p class="text-body-2 text-medium-emphasis mb-4">
          <code>{{ document.document_number }}</code> — kategori dan unit tidak bisa diubah setelah dokumen dibuat
          (BR-001 — perubahan isi wajib lewat "Buat Versi Baru" begitu dokumen published).
        </p>
        <VTextField
          v-model="form.title"
          label="Judul Dokumen *"
          :error-messages="errors.title"
          autofocus
        />
      </VCardText>
      <VCardActions class="pa-6 pt-0">
        <VSpacer />
        <VBtn
          variant="tonal"
          color="secondary"
          :disabled="saving"
          @click="router.push({ name: 'document-id', params: { id: documentId } })"
        >
          Batal
        </VBtn>
        <VBtn
          color="primary"
          :loading="saving"
          @click="save"
        >
          Simpan
        </VBtn>
      </VCardActions>
    </VCard>
  </div>
</template>
